import React, { useEffect, useRef, useState } from "react";
import Api from "../Api";
import { BASE_API_URL } from "../const";
import filmStore from "../../Store/FilmStore";
import { observer } from "mobx-react-lite";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  Paper,
  Button,
  TextField,
  Typography,
  Modal,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import AdsClick from "@mui/icons-material/AdsClick";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { toast } from "react-toastify";
import { toJS } from "mobx";
import { getErrorMessage } from "../../utils/errorHandler";

const MainBodyModal = ({
  openModal,
  handleCloseModal,
  responseAPI,
  hideMetUid,
  selectedFormat,
  repeatLastFilmListRequest,
  getDataListChannels,
}) => {
  const [selectedChannelName, setSelectedChannelName] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [checkboxValues, setCheckboxValues] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [formData, setFormData] = useState({
    channel_id: null,
    files_id: [],
    after_timeline_id: null,
  });
  const [responseListChannels, setResponseListChannels] = useState();
  const [selectedSeasons, setSelectedSeasons] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [afterIdValue, setAfterIdValue] = useState("");
  // Диапазон добавления в дневные планы; stream использует прежний timeline/add.
  const [blockPeriodData, setBlockPeriodData] = useState({
    start_at: "",
    finish_at: "",
  });
  const periodStartInputRef = useRef(null);
  const periodEndInputRef = useRef(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [borderColorMet, setBorderColorMet] = useState("gray");
  const [labelText, setLabelText] = useState("met_uid");
  const [isEditMetUid, setIsEditMetUid] = useState(false);
  const [sortByEpisode, setSortByEpisode] = useState(true);
  const [sendSuccess, setSendSuccess] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isLoadingMet, setIsLoadingMet] = useState(false);
  const [selectedChannelRotation, setSelectedChannelRotation] = useState(null);
  const isSelectedPlannedChannel = Boolean(
    selectedChannelRotation && selectedChannelRotation !== "stream"
  );

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const parseLocalDate = (value) => {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  const addLocalDays = (date, days) => {
    const result = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    result.setDate(result.getDate() + days);
    return result;
  };

  const getNextMonday = () => {
    const today = new Date();
    const daysUntilNextMonday = (8 - today.getDay()) % 7 || 7;
    return addLocalDays(today, daysUntilNextMonday);
  };

  const getSundayOfWeek = (date) => {
    const daysUntilSunday = (7 - date.getDay()) % 7;
    return addLocalDays(date, daysUntilSunday);
  };

  const getDefaultPeriod = () => {
    const monday = getNextMonday();
    return {
      start_at: formatLocalDate(monday),
      finish_at: formatLocalDate(getSundayOfWeek(monday)),
    };
  };

  const formatDateLabel = (value) => {
    if (!value) return "";
    const [year, month, day] = value.split("-");
    return `${day}.${month}.${year}`;
  };

  const showDatePicker = (inputRef, value) => {
    const input = inputRef.current;
    if (!input) return;
    input.value = value;

    try {
      if (typeof input.showPicker === "function") {
        input.showPicker();
        return;
      }
    } catch {
      // Для браузеров без доступного showPicker используем click/focus.
    }

    input.focus();
    input.click();
  };

  const handleOpenPeriodStart = () => {
    const startAt =
      blockPeriodData.start_at || formatLocalDate(getNextMonday());
    const finishAt =
      blockPeriodData.finish_at && blockPeriodData.finish_at >= startAt
        ? blockPeriodData.finish_at
        : formatLocalDate(getSundayOfWeek(parseLocalDate(startAt)));
    setBlockPeriodData({ start_at: startAt, finish_at: finishAt });
    showDatePicker(periodStartInputRef, startAt);
  };

  const handleOpenPeriodEnd = () => {
    const startAt =
      blockPeriodData.start_at || formatLocalDate(getNextMonday());
    const finishAt =
      blockPeriodData.finish_at && blockPeriodData.finish_at >= startAt
        ? blockPeriodData.finish_at
        : formatLocalDate(getSundayOfWeek(parseLocalDate(startAt)));
    setBlockPeriodData({ start_at: startAt, finish_at: finishAt });
    showDatePicker(periodEndInputRef, finishAt);
  };

  const handlePeriodStartChange = (event) => {
    const startAt = event.target.value;
    if (!startAt) {
      setBlockPeriodData({ start_at: "", finish_at: "" });
      return;
    }

    setBlockPeriodData({
      start_at: startAt,
      finish_at: formatLocalDate(getSundayOfWeek(parseLocalDate(startAt))),
    });
  };

  const handlePeriodEndChange = (event) => {
    const startAt =
      blockPeriodData.start_at || formatLocalDate(getNextMonday());
    const finishAt = event.target.value;

    if (finishAt && finishAt < startAt) {
      event.target.value = blockPeriodData.finish_at;
      toast.warning("Дата «По» не может быть раньше даты «С»");
      return;
    }

    setBlockPeriodData({ start_at: startAt, finish_at: finishAt });
  };

  useEffect(() => {
    if (openModal) {
      setBlockPeriodData({ start_at: "", finish_at: "" });
    }
  }, [openModal]);

  useEffect(() => {
    setInputValue(responseAPI.met_uid ?? "");
    setBlockPeriodData({ start_at: "", finish_at: "" });
    getDataListChannels();
    if (!responseAPI.serial) {
      setFormData({
        channel_id: null,
        files_id: [responseAPI.files[0].file_id],
        after_timeline_id: null,
      });
    } else {
      setFormData({ channel_id: null, files_id: [], after_timeline_id: null });
    }
  }, []);

  useEffect(() => {
    if (responseAPI) {
      setInputValue(responseAPI.met_uid ?? "");
      const uniqueSeasons = [
        ...new Set(responseAPI.files.map((file) => file.season)),
      ];
      setSeasons(uniqueSeasons);
    }
    setBlockPeriodData({ start_at: "", finish_at: "" });
    setSelectedValue("");
    setSelectedChannelRotation(null);
    setSelectedCheckboxes([]);
    setSelectedSeasons([]);
    setCheckboxValues([]);
    selectSeason([]);
    if (!responseAPI.serial) {
      setFormData({
        channel_id: null,
        files_id: [responseAPI.files[0].file_id],
        after_timeline_id: null,
      });
    } else {
      setFormData({ channel_id: null, files_id: [], after_timeline_id: null });
    }
  }, [responseAPI]);

  useEffect(() => {
    setSelectedCheckboxes([]);
    setSelectedSeasons([]);
    setCheckboxValues([]);
    selectSeason([]);
    if (responseAPI) {
      setInputValue(responseAPI.met_uid ?? "");
    }
  }, [selectedFormat, selectedChannelName]);

  useEffect(() => {
    if (responseAPI.serial) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        files_id: selectedCheckboxes,
      }));
    }
  }, [selectedCheckboxes]);

  useEffect(() => {
    if (isEditMetUid && inputValue === responseAPI.met_uid) {
      setIsDisabled(false);
    } else {
      setIsDisabled(
        inputValue === "" ||
          labelText === "изменено" ||
          inputValue === responseAPI.met_uid
      );
    }
  }, [inputValue]);

  useEffect(() => {
    setSelectedCheckboxes([]);
    setSelectedSeasons([]);
    setCheckboxValues([]);
    selectSeason([]);
    setSendSuccess(false);
    if (responseAPI.met_uid) {
      setBorderColorMet("blue");
    } else {
      setBorderColorMet("gray");
    }
  }, [responseAPI.title]);

  useEffect(() => {
    if (openModal && !responseAPI.serial) {
      const ids = responseAPI.files
        .filter((file) => file.format === selectedFormat)
        .map((file) => file.file_id);
      setFormData((prev) => ({ ...prev, files_id: ids }));
    }
    if (!openModal) {
      setSelectedChannelRotation(null);
      setSelectedValue("");
      setSelectedChannelName("");
      setBlockPeriodData({ start_at: "", finish_at: "" });
      setAfterIdValue("");
      setFormData((current) =>
        current.channel_id === null && current.after_timeline_id === null
          ? current
          : {
              ...current,
              channel_id: null,
              after_timeline_id: null,
            }
      );
    } else if (selectedValue) {
      const selectedChannel = responseListChannels?.find(
        (channel) => Number(channel.id) === Number(selectedValue)
      );
      setSelectedChannelRotation(selectedChannel?.rotation || null);
    }
  }, [openModal, selectedFormat, selectedValue, responseListChannels]);

  useEffect(() => {
    const storeData = filmStore.addAfterData;

    if (
      selectedValue &&
      storeData &&
      storeData.channel_id === Number(selectedValue)
    ) {
      setFormData((prev) => ({
        ...prev,
        after_timeline_id: storeData.timeline_id,
      }));
      setAfterIdValue(String(storeData.timeline_id));
    } else {
      setFormData((prev) => ({ ...prev, after_timeline_id: null }));
      setAfterIdValue("");
    }
  }, [selectedValue, filmStore.addAfterData]);

  async function getDataListChannels() {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/channel/list`);
      setResponseListChannels(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }

  const handleSelectChange = (event) => {
    const channelId = event.target.value;
    setSelectedValue(channelId);
    setFormData((prevFormData) => ({
      ...prevFormData,
      channel_id: channelId,
    }));

    // Получаем rotation выбранного канала
    const selectedChannel = responseListChannels?.find(
      (channel) => Number(channel.id) === Number(channelId)
    );
    const rotation = selectedChannel?.rotation || null;
    setSelectedChannelRotation(rotation);
    setBlockPeriodData(
      rotation && rotation !== "stream"
        ? getDefaultPeriod()
        : { start_at: "", finish_at: "" }
    );
  };

  const handleCheckboxChange = (id, season) => {
    setSelectedCheckboxes((prev) => {
      const isRemoving = prev.includes(id);
      const updatedCheckboxes = isRemoving
        ? prev.filter((item) => item !== id)
        : [...prev, id];

      setSelectedSeasons((prevSeasons) => {
        if (!isRemoving) {
          return prevSeasons.includes(season)
            ? prevSeasons
            : [...prevSeasons, season];
        } else {
          const hasOtherCheckboxesForSeason = updatedCheckboxes.some(
            (checkboxId) => {
              const checkboxSeason = getSeasonByCheckboxId(checkboxId);
              return checkboxSeason === season;
            }
          );
          return hasOtherCheckboxesForSeason
            ? prevSeasons
            : prevSeasons.filter((s) => s !== season);
        }
      });

      return updatedCheckboxes;
    });
  };

  const getSeasonByCheckboxId = (checkboxId) => {
    if (!Array.isArray(responseAPI.files)) return null;
    const film = responseAPI.files.find((file) => file.file_id === checkboxId);
    return film ? film.season : null;
  };

  const filterFilesByFormat = (fileIds, files, format) => {
    return fileIds.filter((fileId) => {
      const file = files.find((f) => f.file_id === fileId);
      return file && file.format === format;
    });
  };

  // === НОВАЯ ФУНКЦИЯ ===
  const fetchMetUidFromMbase = async () => {
    if (!responseAPI?.id) {
      toast.error("ID контента не найден");
      return;
    }

    setIsLoadingMet(true);

    const isSerial = Boolean(responseAPI.serial);
    const endpoint = isSerial
      ? `${BASE_API_URL}/api/met/serial`
      : `${BASE_API_URL}/api/met/film`;

    try {
      const response = await Api.post(endpoint, {
        mbase_id: responseAPI.id,
      });

      // ←←← ИСПРАВЛЕНИЕ ЗДЕСЬ ←←←
      const newMetUid = response?.data?.data?.met_uid;

      if (newMetUid) {
        setInputValue(String(newMetUid));
        setLabelText("met_uid (получено)");
        setBorderColorMet("green");
        setIsEditMetUid(true);
        toast.success(`met_uid успешно получен: ${newMetUid}`);
      } else {
        toast.warning("В ответе от сервера не найден met_uid");
      }
    } catch (error) {
      console.error("Ошибка при получении met_uid:", error);
      toast.error(
        `❌ ${getErrorMessage(error, "Не удалось получить met_uid")}`
      );
    } finally {
      setIsLoadingMet(false);
    }
  };

  const handleSend = async () => {
    try {
      const response = await Api.post(
        `${BASE_API_URL}/api/movie/met/${responseAPI.id}`,
        {
          met_uid: inputValue,
        }
      );

      if (response.status === 200) {
        repeatLastFilmListRequest();
        setLabelText("изменено");
        setBorderColorMet("blue");
        setIsDisabled(true);
        setIsEditMetUid(true);
        toast.success("met_uid успешно изменён");
      }
    } catch (error) {
      toast.error(
        `❌ ${getErrorMessage(error, "Ошибка при изменении met_uid")}`
      );
    }
  };

  const selectSeason = (seasonNumber) => {
    if (responseAPI) {
      const seasonFiles = responseAPI.files
        .filter((file) => file.season === seasonNumber)
        .map((file) => file.file_id);

      setSelectedCheckboxes((prevSelected) => {
        const updatedSelection = [
          ...new Set([...prevSelected, ...seasonFiles]),
        ];
        return updatedSelection;
      });
    }
  };

  const handleCheckboxChangeSeason = (event, season) => {
    const { checked } = event.target;
    setSelectedSeasons((prevSelected) =>
      checked
        ? [...prevSelected, season]
        : prevSelected.filter((s) => s !== season)
    );

    if (checked) {
      selectSeason(season);
    } else {
      const seasonFiles = responseAPI.files
        .filter((file) => file.season === season)
        .map((file) => file.file_id);

      setSelectedCheckboxes((prevSelected) =>
        prevSelected.filter((fileId) => !seasonFiles.includes(fileId))
      );
    }
  };

  const handleCheckboxChangeSortByEpisode = () => {
    setSortByEpisode((v) => !v);
  };

  const handleAfterIdChange = (event) => {
    const value = event.target.value;
    setAfterIdValue(value);
    setFormData((prev) => ({
      ...prev,
      after_timeline_id: value ? Number(value) : null,
    }));
  };

  const handleClearAfterId = () => {
    setAfterIdValue("");
    setFormData((prev) => ({ ...prev, after_timeline_id: null }));
    filmStore.clearAddAfterData();
    toast.info("ID для добавления после очищен");
  };

  const closeModalWithReset = () => {
    setSelectedValue("");
    setSelectedChannelName("");
    setSelectedChannelRotation(null);
    setBlockPeriodData({ start_at: "", finish_at: "" });
    setAfterIdValue("");
    setFormData((current) => ({
      ...current,
      channel_id: null,
      after_timeline_id: null,
    }));
    setSelectedCheckboxes([]);
    setSelectedSeasons([]);
    setCheckboxValues([]);
    selectSeason([]);
    filmStore.clearAddAfterData();
    handleCloseModal();
  };

  const handleClickSendData = () => {
    if (isSending) return;

    const isBlockChannel = isSelectedPlannedChannel;
    let preparedFileIds = filterFilesByFormat(
      formData.files_id || [],
      responseAPI.files,
      selectedFormat
    );

    if (!formData.channel_id || preparedFileIds.length === 0) return;

    if (isBlockChannel) {
      if (!blockPeriodData.start_at || !blockPeriodData.finish_at) {
        toast.warning("Выберите даты «С» и «По»");
        return;
      }
      if (blockPeriodData.finish_at < blockPeriodData.start_at) {
        toast.warning("Дата «По» не может быть раньше даты «С»");
        return;
      }
    }

    if (sortByEpisode) {
      const episodeMap = new Map(
        responseAPI.files.map((item) => [
          item.file_id,
          { season: item.season, episode: item.episode },
        ])
      );

      preparedFileIds = preparedFileIds.slice().sort((a, b) => {
        const dataA = episodeMap.get(a);
        const dataB = episodeMap.get(b);
        if (!dataA || !dataB) return 0;
        if (dataA.season === dataB.season) {
          return dataA.episode - dataB.episode;
        }
        return dataA.season - dataB.season;
      });
    }

    let addedWeekFiles = 0;
    const request = isBlockChannel
      ? preparedFileIds.reduce(
          (chain, fileId) =>
            chain.then(() =>
              Api.post(`${BASE_API_URL}/api/channel-days-plan/week/add`, {
                channel_id: Number(formData.channel_id),
                file_id: Number(fileId),
                start_at: blockPeriodData.start_at,
                finish_at: blockPeriodData.finish_at,
              }).then((response) => {
                addedWeekFiles += 1;
                return response;
              })
            ),
          Promise.resolve(null)
        )
      : Api.post(`${BASE_API_URL}/api/timeline/add`, {
          ...formData,
          files_id: preparedFileIds,
        });

    setIsSending(true);
    request
      .then((response) => {
        // ... твой оригинальный код формирования successMessage ...
        const responseArray = Array.isArray(responseAPI)
          ? responseAPI.slice().map((item) => toJS(item))
          : [toJS(responseAPI)];

        const filesArray = [];
        responseArray.forEach((item) => {
          if (item.files && Array.isArray(item.files)) {
            filesArray.push(...item.files.map((file) => toJS(file)));
          }
        });

        const sentItems = preparedFileIds
          .map((fileId) => {
            const fileData = filesArray.find((f) => f.file_id == fileId);
            if (!fileData) return null;

            const parentItem = responseArray.find((item) =>
              item.files?.some((f) => f.file_id == fileId)
            );

            const isSeries = fileData.season > 0 || fileData.episode > 0;

            return {
              title: parentItem?.title || parentItem?.name || "Без названия",
              type: isSeries ? "series" : "movie",
              season: fileData.season || 0,
              episode: fileData.episode || 0,
            };
          })
          .filter(Boolean);

        let successMessage = isBlockChannel
          ? `Добавлено в дневные планы файлов: ${addedWeekFiles}. `
          : "Добавлено: ";
        if (sentItems.length === 1) {
          const item = sentItems[0];
          successMessage +=
            item.type === "series"
              ? `${item.title} (Сезон ${item.season}, Серия ${item.episode})`
              : item.title;
        } else {
          const titles = sentItems.map((item) =>
            item.type === "series"
              ? `${item.title} (С${item.season}E${item.episode})`
              : item.title
          );
          successMessage += titles.slice(0, 3).join(", ");
          if (titles.length > 3)
            successMessage += ` и ещё ${titles.length - 3}`;
        }

        setFormData({
          channel_id: null,
          files_id: [],
          after_timeline_id: null,
        });
        setAfterIdValue("");
        setBlockPeriodData({ start_at: "", finish_at: "" });
        setSelectedCheckboxes([]);
        setSelectedSeasons([]);
        selectSeason([]);
        setCheckboxValues([]);
        setSelectedValue("");
        filmStore.getDataListChannels();
        filmStore.clearAddAfterData();
        setSendSuccess(true);

        toast.success(successMessage);
        closeModalWithReset();
      })
      .catch((error) => {
        const partialMessage =
          isBlockChannel && addedWeekFiles > 0
            ? ` Добавлено файлов до ошибки: ${addedWeekFiles}.`
            : "";
        toast.error(
          `❌ ${getErrorMessage(
            error,
            "Ошибка при отправке данных"
          )}.${partialMessage}`
        );
        if (!isBlockChannel) closeModalWithReset();
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    setLabelText("met_uid");
    setBorderColorMet("red");
  };

  return (
    <Modal open={openModal} onClose={closeModalWithReset}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 575,
          maxWidth: 575,
          minWidth: 575,
          maxHeight: "90vh",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ p: 4, pb: 0, flex: 1, overflowY: "auto" }}>
          <Paper
            sx={{
              backgroundColor: "#E0F7FA",
              padding: 1,
              borderRadius: 2,
              marginBottom: 2,
              width: 480,
              maxWidth: 480,
              minWidth: 480,
            }}
          >
            <Typography variant="h6" align="center" color="primary">
              {responseAPI.title} - {selectedFormat}
            </Typography>
          </Paper>

          <Paper
            sx={{
              backgroundColor: "#E0F7FA",
              padding: 1,
              borderRadius: 2,
              width: 480,
              maxWidth: 480,
              minWidth: 480,
              overflowX: "auto",
            }}
          >
            {responseAPI && responseListChannels && (
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <Select
                          value={selectedValue}
                          onChange={handleSelectChange}
                          displayEmpty
                          fullWidth
                        >
                          <MenuItem value="">
                            <em>Выберите канал</em>
                          </MenuItem>
                          {responseListChannels.map((element, index) => (
                            <MenuItem key={index} value={element.id}>
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                    </TableRow>

                    {responseAPI.serial && (
                      <TableRow>
                        <TableCell colSpan={seasons.length}>
                          <Box display="flex" flexWrap="wrap" maxWidth="400px">
                            {seasons.map((season) => (
                              <FormControlLabel
                                key={season}
                                control={
                                  <Checkbox
                                    checked={selectedSeasons.includes(season)}
                                    onChange={(event) =>
                                      handleCheckboxChangeSeason(event, season)
                                    }
                                  />
                                }
                                label={`Сезон ${season}`}
                                sx={{ flexShrink: 0 }}
                              />
                            ))}
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={sortByEpisode}
                                  onChange={handleCheckboxChangeSortByEpisode}
                                />
                              }
                              label={"Сортировка по порядку"}
                              sx={{ flexShrink: 0 }}
                            />
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}

                    <TableRow>
                      <TableCell
                        colSpan={seasons.length + 1}
                        sx={{ maxWidth: 390 }}
                      >
                        <Box sx={{ mb: 3 }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                            }}
                          >
                            <TextField
                              label="Add after this ID"
                              variant="outlined"
                              type="number"
                              value={afterIdValue}
                              onChange={handleAfterIdChange}
                              fullWidth
                              autoComplete="off"
                              inputProps={{ form: "off", min: 1 }}
                              sx={{ maxWidth: "380px" }}
                            />

                            <Tooltip title="Очистить ID" arrow>
                              <IconButton
                                onClick={handleClearAfterId}
                                disabled={!afterIdValue}
                                aria-label="Очистить ID для добавления после"
                                sx={{ width: 48, height: 48 }}
                              >
                                <CleaningServicesIcon sx={{ fontSize: 34 }} />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </Box>

                        {/* Временно отключено: поле met_uid, получение из mbase и изменение. */}
                        {!hideMetUid && false && (
                          <>
                            <Box sx={{ mb: 3 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                }}
                              >
                                <TextField
                                  label={labelText}
                                  variant="outlined"
                                  value={inputValue}
                                  onChange={handleInputChange}
                                  fullWidth
                                  autoComplete="off"
                                  inputProps={{ form: "off" }}
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      "& fieldset": {
                                        borderColor: borderColorMet,
                                      },
                                      "&:hover fieldset": {
                                        borderColor: borderColorMet,
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: borderColorMet,
                                      },
                                    },
                                    maxWidth: "380px", // укороченное поле
                                  }}
                                />

                                <IconButton
                                  color="primary"
                                  onClick={fetchMetUidFromMbase}
                                  disabled={isLoadingMet}
                                  title="Получить met_uid из mbase"
                                  sx={{ width: 48, height: 48 }}
                                >
                                  {isLoadingMet ? (
                                    <CircularProgress size={24} />
                                  ) : (
                                    <AdsClick sx={{ fontSize: 34 }} />
                                  )}
                                </IconButton>
                              </Box>
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                mb: 3,
                              }}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSend}
                                disabled={isDisabled}
                              >
                                изменить met_uid
                              </Button>
                            </Box>
                          </>
                        )}

                        {isSelectedPlannedChannel && (
                          <Box
                            sx={{
                              position: "relative",
                              display: "flex",
                              justifyContent: "center",
                              gap: 1.5,
                              mb: 3,
                            }}
                          >
                            <Button
                              variant="outlined"
                              onClick={handleOpenPeriodStart}
                            >
                              {blockPeriodData.start_at
                                ? `С: ${formatDateLabel(
                                    blockPeriodData.start_at
                                  )}`
                                : "С"}
                            </Button>
                            <Button
                              variant="outlined"
                              onClick={handleOpenPeriodEnd}
                            >
                              {blockPeriodData.finish_at
                                ? `По: ${formatDateLabel(
                                    blockPeriodData.finish_at
                                  )}`
                                : "По"}
                            </Button>

                            <input
                              ref={periodStartInputRef}
                              type="date"
                              value={blockPeriodData.start_at}
                              onChange={handlePeriodStartChange}
                              aria-label="Дата начала диапазона вещания"
                              tabIndex={-1}
                              style={{
                                position: "absolute",
                                opacity: 0,
                                pointerEvents: "none",
                              }}
                            />
                            <input
                              ref={periodEndInputRef}
                              type="date"
                              value={blockPeriodData.finish_at}
                              min={blockPeriodData.start_at || undefined}
                              onChange={handlePeriodEndChange}
                              aria-label="Дата окончания диапазона вещания"
                              tabIndex={-1}
                              style={{
                                position: "absolute",
                                opacity: 0,
                                pointerEvents: "none",
                              }}
                            />
                          </Box>
                        )}

                        {responseAPI.files.some(
                          (file) => file.episode === 111
                        ) && (
                          <Typography
                            variant="subtitle1"
                            color="error"
                            align="center"
                            sx={{ fontWeight: "bold", marginBottom: "8px" }}
                          >
                            ❗ есть 111 серия!
                          </Typography>
                        )}

                        {responseAPI.serial && (
                          <Box
                            sx={{
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              padding: "6px",
                              marginBottom: "16px",
                              width: "95%",
                              minHeight: "50px",
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                display: "block",
                                fontSize: "12px",
                                marginBottom: "4px",
                                textAlign: "center",
                                color: "gray",
                              }}
                            >
                              Выбранные серии
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "14px",
                                lineHeight: "1.4",
                                textAlign: "center",
                              }}
                            >
                              {selectedSeasons
                                .map((season) => {
                                  const selectedFiles = responseAPI.files
                                    .filter(
                                      (file) =>
                                        file.season === season &&
                                        file.format === selectedFormat &&
                                        selectedCheckboxes.includes(
                                          file.file_id
                                        )
                                    )
                                    .map((file) => file.episode);

                                  if (selectedFiles.length === 0) return null;

                                  const groupedSeries = [];
                                  let rangeStart = null;

                                  for (
                                    let i = 0;
                                    i < selectedFiles.length;
                                    i++
                                  ) {
                                    if (rangeStart === null) {
                                      rangeStart = selectedFiles[i];
                                    }

                                    if (
                                      selectedFiles[i + 1] !==
                                        selectedFiles[i] + 1 ||
                                      i === selectedFiles.length - 1
                                    ) {
                                      if (rangeStart === selectedFiles[i]) {
                                        groupedSeries.push(`${rangeStart}`);
                                      } else {
                                        groupedSeries.push(
                                          `${rangeStart}-${selectedFiles[i]}`
                                        );
                                      }
                                      rangeStart = null;
                                    }
                                  }

                                  return `Сезон ${season}, серии ${groupedSeries.join(
                                    ", "
                                  )}`;
                                })
                                .filter(Boolean)
                                .join("; ")}
                            </Typography>
                          </Box>
                        )}

                        {responseAPI.serial ? (
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: `repeat(${seasons.length}, 1fr)`,
                              maxHeight: "400px",
                              maxWidth: 440,
                              minWidth: 440,
                              width: 400,
                              overflowY: "auto",
                              overflowX: "auto",
                            }}
                          >
                            {seasons.map((season) => {
                              const seasonFiles = responseAPI.files.filter(
                                (file) =>
                                  file.season === season &&
                                  file.format === selectedFormat
                              );

                              return (
                                <Box
                                  key={season}
                                  sx={{
                                    border: "1px solid #ddd",
                                    padding: "2px",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle1"
                                    align="center"
                                    sx={{
                                      marginBottom: "8px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Сезон {season}
                                  </Typography>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {seasonFiles.map((file) => (
                                      <FormControlLabel
                                        key={file.file_id}
                                        control={
                                          <Checkbox
                                            checked={selectedCheckboxes.includes(
                                              file.file_id
                                            )}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                file.file_id,
                                                file.season
                                              )
                                            }
                                            sx={{ padding: "1px" }}
                                          />
                                        }
                                        label={
                                          <Box
                                            component="span"
                                            sx={{
                                              fontSize: "11px",
                                              lineHeight: "1.2",
                                            }}
                                          >
                                            серия {file.episode}
                                          </Box>
                                        }
                                        sx={{ margin: 0 }}
                                      />
                                    ))}
                                  </Box>
                                </Box>
                              );
                            })}
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              padding: "8px",
                              maxHeight: "300px",
                              overflowY: "auto",
                              rowGap: "4px",
                            }}
                          >
                            {responseAPI.files
                              .filter((file) => file.format === selectedFormat)
                              .map((file) => (
                                <FormControlLabel
                                  key={file.file_id}
                                  control={
                                    <Checkbox
                                      checked={true}
                                      sx={{ padding: "4px" }}
                                    />
                                  }
                                  label={file.name}
                                  sx={{ margin: 0 }}
                                />
                              ))}
                          </Box>
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        </Box>

        <Box
          sx={{
            textAlign: "center",
            mt: 2,
            mb: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Button
            onClick={handleClickSendData}
            variant="contained"
            color="primary"
            disabled={
              isSending ||
              !(
                formData.channel_id !== null &&
                Array.isArray(formData.files_id) &&
                formData.files_id.length > 0 &&
                selectedChannelRotation &&
                (selectedChannelRotation === "stream" ||
                  (blockPeriodData.start_at && blockPeriodData.finish_at))
              )
            }
          >
            {isSending ? (
              <CircularProgress size={22} color="inherit" />
            ) : isSelectedPlannedChannel ? (
              "Добавить в дневные планы"
            ) : (
              "Отправить"
            )}
          </Button>
          {sendSuccess && (
            <CheckIcon sx={{ color: "green", fontSize: 24, marginLeft: 1 }} />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default observer(MainBodyModal);
